export const environment = {
  production: false,
  current: 'Development mode',
  baseUrl: 'https://wahii-dev.firebaseapp.com/fuel/',
  apiURL: 'https://us-central1-wahii-dev.cloudfunctions.net/api',
  assets: './assets/',
  googleMapsKey: {
    map: 'AIzaSyBvWTxTiSwmnGtXxJfdn3RYDeVtTbBLjD0',
    geocoding: 'AIzaSyBvWTxTiSwmnGtXxJfdn3RYDeVtTbBLjD0'
  },
  stripeKey: "pk_test_UJB9x0NptEAIN8ZZOaofqc9y",
  firebaseConfig: {
    apiKey: "AIzaSyAZOiJ1JJTSi0h8p4Y3PxoY-kPGIbEGCpc",
    authDomain: "wahii-dev.firebaseapp.com",
    databaseURL: "https://wahii-dev.firebaseio.com",
    projectId: "wahii-dev",
    storageBucket: "wahii-dev.appspot.com",
    messagingSenderId: "839061900701"
  }
};
